import React from 'react';
import { Receipt, ArrowRight } from 'lucide-react';
import { Button } from '@/components/Button';

interface BannerSlideProps {
    isLoggedIn: boolean;
}

export const PointsRequestBannerSlide: React.FC<BannerSlideProps> = ({ isLoggedIn }) => {
    return (
        <div className="w-full shrink-0 flex flex-col md:flex-row items-center gap-6 px-4">
            <div className="flex relative z-10 shrink-0 group-hover:scale-105 transition-transform duration-500">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-emerald-400 to-teal-600 flex items-center justify-center border-4 border-white dark:border-gray-900 shadow-2xl relative">
                    <Receipt className="w-10 h-10 md:w-14 md:h-14 text-white drop-shadow-md" />
                </div>
            </div>
            <div className="flex-1 text-center md:text-left z-10 mt-4 md:mt-0">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-gradient-to-r from-emerald-500/10 to-teal-500/10 border border-emerald-500/20 rounded-full text-emerald-600 dark:text-emerald-400 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-3">
                    <Receipt className="w-3.5 h-3.5 fill-current" />
                    Pós-Compras
                </div>
                <h3 className="text-xl md:text-2xl font-black text-gray-900 dark:text-white mb-2 leading-tight">
                    Comprou? Solicite seus pontos!
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 font-medium mb-5 text-balance">
                    Acumule pontos em compras nas plataformas parceiras. Envie o comprovante e veja seus pontos do Radar crescerem.
                </p>
                <div className="flex items-center justify-center md:justify-start">
                    <Button
                        variant="primary"
                        className="bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 shadow-lg shadow-teal-500/25 border-0 text-sm px-6 py-2.5 whitespace-nowrap"
                    >
                        {isLoggedIn ? 'Solicitar Pontos' : 'Solicitar Pontos'}
                        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                </div>
            </div>
        </div>
    );
};
